import styled from "@emotion/styled";


export const Container = styled.div`
    width:100%;
    height:100%;
    position: relative;
    
    > div > div {
        display:none;
    }

    video{
        height:100% !important;
        width:100% !important;
        object-fit: cover;
    }
`;